// extracted by mini-css-extract-plugin
module.exports = {"metrics":"Metrics_metrics__36EJG","metric":"Metrics_metric__3uJLq","dark":"Metrics_dark__f4S87","fadeIn":"Metrics_fadeIn__2Zgq8","scaleXin":"Metrics_scaleXin__wi_Ph"};